export default __webpack_public_path__ + "static/media/react-logo.8bd6f5b5.png";